import React from 'react';

import { useSelector } from 'react-redux';

import Loading from 'components/module/Loading';
import { PlatForm } from 'types/store/LoginState';
import { Store } from 'types/store/Store';
import LoadingProfile from 'routes/Auth/Advocate/Register/LoadingProfile';

/**
 * Route level loading state.
 *
 * Right after an advocate logs in we keep showing the same screen the login
 * form was showing, so landing on My Stories does not flash a second, different
 * spinner. `login.data` is only set on a successful login and is not persisted,
 * so a refresh (or any other flow) falls back to the original loader.
 */
const RouteLoading = (): React.JSX.Element => {
  const isAdvocateLogin = useSelector(
    (state: Store) => state.login?.data?.data?.platform === PlatForm.ADVOCATE,
  );

  return isAdvocateLogin ? <LoadingProfile isRegister={false} /> : <Loading />;
};

export default React.memo(RouteLoading);
